
export class DrgCombo {
   public DRG: string = '0';
   public CPT: string[] = [];
   public PreviousDrg: string = '0';
}